import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient, private router: Router, private toastr: ToastrService) { }

  postFormRequest(url: string, data: FormData) {
    let params = new HttpParams();

    const options = {
      params: params,
      reportProgress: true,
    };

    return this.http.post(url, data, options)
      .pipe(
        map(res => {
          if (res['response'] === 401) {
            this.handleUnauthenticated();
          }

          else if (res['response'] === 200 || res['response'] === 304) {
            return {
              data: res['data'],
              response: res['response'],
              success: res['success'],
              message: res['message'],
            }
          } else {

            throw new Error(res['message']);
          }

        }),
        catchError(err => this.handleError(err))
      );
  }

  putFormRequest(url: string, data: FormData) {
    let params = new HttpParams();

    const options = {
      params: params,
      reportProgress: true,
    };

    return this.http.put(url, data, options)
      .pipe(
        map(res => {

          if (res['response'] === 401) {
            this.handleUnauthenticated();
          }

          else if (res['response'] === 200 || res['response'] === 304 && res['success'] === 1) {
            return {
              data: res['data'],
              response: res['response'],
              success: res['success'],
              message: res['message'],
            }
          } else {

            throw new Error(res['message']);
          }

        }),
        catchError(err => this.handleError(err))
      );
  }

  // handles all GET Requests, sends the whole response/error to component
  getRequest(url, params = {}, showerror = true) {
    return this.http.get(url, { params: params, observe: 'response' })
      .pipe(
        map(res => {
          if (res['response'] === 401) {
            this.handleUnauthenticated();
          }
          else if ((res['status'] === 200 || res['response'] === 200 || res['response'] === 304)) {
            return {
              data: res.body['data'],
              response: res.body['response'],
              success: res.body['success'],
              message: res.body['message'],
            }
          } else if (showerror) {
            throw new Error(res.body['message']);
          }
        }),
        // catchError((err) => {
        //   if (showerror) {
        //     return this.handleError(err)
        //   } else {
        //     err = '';
        //     return this.handleError(err)
        //   }
        // })
        catchError(err => this.handleError(err))
      );
  }

  // handles all POST Requests. Headers are optional, sends the whole response/error to component
  postRequest(url, params, headers = {}) {
    let httpOptions = this.checkHeaders(headers);

    return this.http.post(url, params, { headers: httpOptions })
      .pipe(
        map(res => {
          if (res['response'] === 401) {
            this.handleUnauthenticated();
          }

          else if (res['response'] === 200 || res['response'] === 304) {
            return {
              data: res['data'],
              response: res['response'],
              success: res['success'],
              message: res['message']
            }
          }
          else if (res['data'].code == '012') {
            return {
              data: res['data'],
              response: res['response'],
              success: res['success'],
              message: res['message']
            }
          }
          else {

            throw new Error(res['message']);
          }

        }),
        // catchError((error: HttpErrorResponse) => {
        //   return this.handleError(error);
        // })
        catchError(err => this.handleError(err))
      );
  }

  // handles all POST Requests. Headers are optional, sends the whole response/error to component
  putRequest(url, params, headers = {}) {
    let httpOptions = this.checkHeaders(headers);

    return this.http.put(url, params, { headers: httpOptions })
      .pipe(
        map(res => {
          if (res['response'] === 401) {
            this.handleUnauthenticated();
          }

          else if (res['response'] === 200 || res['response'] === 304) {
            return {
              data: res['data'],
              response: res['response'],
              success: res['success'],
              message: res['message']
            }
          }
          else if (res['response'] === '1001') {
            return {
              data: res['data'],
              response: res['response'],
              success: res['success'],
              message: res['message']
            }
          }
          else {
            throw new Error(res['message']);
          }

        }),
        catchError((error: HttpErrorResponse) => this.handleError(error))
      );
  }

  deleteRequest(url, params, headers = {}) {
    const options = {
      params: params,
      reportProgress: true,
    };
    // console.log(options);
    return this.http.delete(url, options)
      .pipe(
        map(res => {

          if (res['response'] === 401) {
            this.handleUnauthenticated();
          }

          else if (res['response'] === 200 || res['response'] === 304 && res['success'] === 1) {
            return {
              data: res['data'],
              response: res['response'],
              success: res['success'],
              message: res['message'],
            }
          } else {

            throw new Error(res['message']);
          }

        }),
        catchError(err => this.handleError(err))
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      const status = error && error.status;
      const message = error.error && error.error.message;
      const isAuthFailure =
        status === 401 ||
        status === 403 ||
        message === 'User is not authenticated' ||
        message === 'User is not authorized to visit the api';

      if (isAuthFailure) {
        // Prefer HTTP 401/403 from passport; don't trust body.response (often still 200).
        this.handleUnauthenticated(
          status === 403 || message === 'User is not authorized to visit the api'
            ? 'Please log in again.'
            : 'Please Login first'
        );
      } else {
        if (message) {
          this.showError(message);
        } else {
          this.showError(error);
        }
      }

      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    if (error.error)
      return throwError(error.error.message);
    else
      return throwError(error);
  };

  // append headers in http requests
  private checkHeaders(headers) {
    if (Object.keys(headers).length) {
      return headers;
    } else return {
      'Content-Type': 'application/json',
    }
  }

  handleUnauthenticated(msg: string = '') {
    if (msg) this.showError(msg);
    // Match manual logout: clear admin session UI state, then force login.
    // Do not call /admin/logout here — cookie may be merchant/wrong role and that call would also 403.
    localStorage.removeItem('token');
    localStorage.removeItem('darkCarz-admin-data');
    sessionStorage.clear();
    return this.router.navigateByUrl('/login');
  }

  uploadImage(url, fileToUpload: File) {
    var fd = new FormData();
    fd.append('image', fileToUpload);
    return this.http.post(url, fd)
      .pipe(
        map(res => {

          if (res['response'] === 401) {

            localStorage.removeItem("user");
            this.router.navigateByUrl('/auth/login');
          }

          return {
            data: res['data'],
            message: res['message'],
          }
        }),
        catchError(err => this.handleError(err))
      );
  }

  showSuccess = (msg, title) => {
    this.toastr.success(msg, title, {
      closeButton: true,
      timeOut: 1000
    });
  }

  showError = (msg, title = '') => {
    if (msg) {
      this.toastr.error(msg, title, {
        closeButton: true,
        timeOut: 3000
      });
    }
    // else {
    //   this.toastr.error(null, 'Unable to connect to server.', {
    //     closeButton: true,
    //     timeOut: 3000
    //   });
    // }
  }
}


